import { createFileRoute, Outlet, useMatch } from '@tanstack/react-router';

import { HeaderNavigationBase } from '@/components/navigation/header-navigation';

/**
 * Layout for external participants: people admitted to one study through a
 * project's external invite link. They hold a shim account with no profile,
 * so none of the participant layout's gates (email verified, onboarding,
 * lead status, agreement modal) apply, and none of its navigation either —
 * the study is the only thing they can reach. The header is the logo-only
 * bar a signed-out visitor sees; the interview draws its own chrome and gets
 * the full viewport, as it does in the participant app.
 *
 * Who they are comes from the project's own external session, checked by the
 * project route below, never from the participant app's session: someone
 * signed into the participant app on this browser stays signed in.
 */
export const Route = createFileRoute('/participants/_external')({
  component: ExternalLayout,
});

function ExternalLayout() {
  const isInterview =
    useMatch({
      from: '/participants/_external/external/projects/$projectId/interview',
      shouldThrow: false,
    }) != null;

  if (isInterview) {
    return (
      <main className="flex h-dvh flex-col bg-primary">
        <Outlet />
      </main>
    );
  }

  return (
    <div className="flex min-h-screen flex-col bg-primary">
      <HeaderNavigationBase items={[]} showAvatarDropdown={false} user={null} />
      <main className="flex-1 bg-secondary">
        <Outlet />
      </main>
    </div>
  );
}
